import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useInsurerListsStyles = makeStyles((theme: Theme) => createStyles({
  insurerAvatar: {
    backgroundColor: theme.palette.primary.light,
  },
}));

export default useInsurerListsStyles;
